module.exports = __webpack_public_path__ + "static/media/bartop-fade.2eb98d28.jpg";